import * as React from 'react';
import OEITable from './OEITable';
import {doNothing} from './OEIUtils';
import config from "../configurations/config";
import {fetchNotificationDataWithIntgAccId,deleteNotificationMapping} from './APIService'
import { EMPTY, LOADING } from './Constants';
const columns = [
  { id: 'notificationType',label: 'Notification',align: 'left',width:'25%',button:false},
  { id: 'active', label: 'Active',button:false,edit :false,width:'25%'},
  { id: 'emailAddresses', label: 'Email Addresses',button:false,edit :false,width:'25%'},
  { id: 'Manage', label: EMPTY,buttonLabel:'Edit', button: true, edit: false, width: '10%' }

];
export default function Notification(props) {
 
  const [newNotificationData,setnewNotificationData]=React.useState([]);
  const [errorMessage, seterrorMessage] = React.useState(EMPTY);
  const [NotificationMappings,setNotificationMappings]=React.useState([]);
  const [checked,setChecked]=React.useState(false);
  const [closePopover, setClosePopover]=React.useState(true);
  const [message,setMessage]=React.useState(LOADING);
  const [email,setEmail]=React.useState(false);
  const [errors, setErrors] = React.useState({ error1: EMPTY, error2: EMPTY, error3: EMPTY });

  const getNotificationMappings=()=>{
    const newArr = NotificationMappings.map((element, index) => {
      return {...element,id:element.notificationType};
    });
    return newArr;
  }
  React.useEffect(function () {
    fetchNotificationMappingData(props.match.params.id);
  },[])
const fetchNotificationMappingData = (id) => {
  fetchNotificationDataWithIntgAccId(id).then(response=>{
    response.length===0?setMessage('There are no Notifications mapped'):setMessage(EMPTY)
    setNotificationMappings(response);
  })
};
const createNotificationMapping = (e) => {
  if(newNotificationData.emails.length>1||newNotificationData.allEmails.length>1){
  const integrationAccountId=props.match.params.id
  fetch(config.apiGateway.URL + "accounts/notification", {
    method: "POST",
    headers: { 'X-OEX-Int-Authorization': sessionStorage.getItem('idToken') },
   body: JSON.stringify({integrationAccountId:integrationAccountId,
    emailAddresses:newNotificationData.emails,
    notificationType:newNotificationData.selectedValue==='Event Edited'?'Event Updated':newNotificationData.selectedValue,
    allEmailAddresses:newNotificationData.allEmails})
  }).then(response => response.json())
    .then(data => {
      if(data.account!==undefined){
        setClosePopover(true)
        setErrors([])
        setChecked(false)
        fetchNotificationMappingData(integrationAccountId)  
      }
    else if(data.message.includes('already exists')) {
        setErrors({...errors,error1:'Notification with given system is already exists.'});
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.status === 403 || error.response.status === 400 || error.response.status === 401) {
          alert("session expired");
        }
      }
    });
}else{
  setErrors({...errors,error2:'Minimum of 1 email address is required'})
}
}
const editNotificationMapping=(row)=>{
    if(row.emailAddresses.length < 1 && row.allEmailAddresses.length < 1){
      setErrors({...errors,error2:'Minimum of 1 email address is required'})
    }else{
    fetch(config.apiGateway.URL + "accounts/notification", {
      method: "PUT",
      headers: { 'X-OEX-Int-Authorization': sessionStorage.getItem('idToken') },
      body: JSON.stringify({ integrationAccountId: row.integrationAccountId, emailAddresses: row.emailAddresses, notificationType: row.notificationType ,allEmailAddresses:row.allEmailAddresses })
    }).then(response => {
      setClosePopover(true)
      fetchNotificationMappingData(row.integrationAccountId)})
    }
}
const deleteNotification=(e)=>{
deleteNotificationMapping(e.integrationAccountId,e.notificationType).then(response => {
  setClosePopover(true)
  fetchNotificationMappingData(e.integrationAccountId)
})
   }
    return (
    <>
     <OEITable match={props.match}removeMainItem={doNothing} tabClicked='notification' history={props.history} headerStyle='sticky-header1'tableHeaderStyle= 'table-header1'
     closePopover={closePopover} setClosePopover={setClosePopover} onclick={createNotificationMapping}errors={errors} setErrors={setErrors}
	checked={checked}setChecked={setChecked} setGenerate={doNothing} email={email}setEmail={setEmail}
	errorMessage={errorMessage} setErrorMessage={seterrorMessage} rowData={getNotificationMappings()} 
	newData={newNotificationData}setNewData={setnewNotificationData} columns={columns} submenu='true' newAction='Notification' 
	tableHeadings={sessionStorage.systemName}edit={editNotificationMapping}message={message} delete={deleteNotification}></OEITable> 
      </>
  )
};